import React from 'react';
import { Provider } from 'react-redux';
import store from '../../redux/store';
import RecentItemsContent from './RecentItemsContent';

const Cart = (props) => (
  <Provider store={store}>
    <RecentItemsContent {...props} />
  </Provider>
);

export default Cart;
